module.exports = __webpack_public_path__ + "img/class_success.0835d36d.png";